// Крестик закрытия модального окна.
//
// Одна и та же разметка со стилями лежала копиями в ConfirmDialog и DigitalSignDialog. Вынесена,
// чтобы правка вида/отступов не расползалась по файлам и не расходилась между окнами.
import styled from "styled-components";

interface DialogCloseButtonProps {
  onClick: () => void;
  /** Для тестов и e2e: у каждого окна свой идентификатор. */
  id?: string;
}

const DialogCloseButton = (props: DialogCloseButtonProps) => (
  <CloseModal type="button" aria-label="close" id={props.id} onClick={props.onClick} />
);

export default DialogCloseButton;

const CloseModal = styled.button`
  border: none;
  outline: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 38px;
  right: 30px;
  width: 24px;
  height: 24px;
  font-size: 16px;
  opacity: 0.6;
  transition: opacity ease 0.3s;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 10px;
    display: block;
    width: 18px;
    height: 3px;
    background: var(--colorBrandForeground1);
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;
